import AnimationLine from './animation-line.view';

export default AnimationLine;
